export default class HorarioFlexivel {
    constructor() {
        this.id = null;
        this.entrada1 = null;
        this.saida1 = null;
        this.entrada2 = null;
        this.saida2 = null;
        this.entrada3 = null;
        this.saida3 = null;
    }
}